import departmentACIcon from '@/assets/icons/department-acs.svg';
import productsACIcon from '@/assets/icons/product-and-services.svg';
import projectsACIcon from '@/assets/icons/project-acs.svg';
import contractsACIcon from '@/assets/icons/contracts-acs.svg';

export type ACType = 'DEPARTMENT_ACCOUNTING' | 'PRODUCTS_AND_SERVICES' | 'PROJECTS' | 'CONTRACTS';

export const ACCOUNTING_CENTERS_ICONS: Record<ACType, string> = {
  DEPARTMENT_ACCOUNTING: departmentACIcon,
  PRODUCTS_AND_SERVICES: productsACIcon,
  PROJECTS: projectsACIcon,
  CONTRACTS: contractsACIcon
};
